import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Layout, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { get } from 'lodash';
import PdButton from 'components/pd-button';
import { AuthenticationContext } from 'contexts/authentication';

import './style.scss';

const { Content } = Layout;

export function LoginPage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { login } = useContext(AuthenticationContext);

  async function handleLogin(payload) {
    try {
      await login(payload);

      navigate({
        pathname: '/',
      });
    } catch (err) {
      const errMessage = get(
        get(get(err, 'response', {}), 'data', {}),
        'message',
        ''
      );
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    }
  }

  async function handleSubmit(values) {
    try {
      await handleLogin(values);
    } catch {
      // Error handling is done in handleLogin
    }
  }

  return (
    <Content className="pd-login">
      <div className="logo-container pd-margin-bottom-lg">
        <img
          className="pd-header-logo"
          src="/img/logo/homestory.png"
          alt="Company Logo"
        />
      </div>
      <Form form={form} onFinish={handleSubmit} className="login-form">
        <Form.Item
          name="email"
          rules={[{ required: true, message: 'Please input your email!' }]}>
          <Input
            prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder="Email"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your Password!' }]}>
          <Input
            prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item>
          <PdButton type="primary" full={true} htmlType="submit">
            Log In
          </PdButton>
        </Form.Item>
      </Form>
    </Content>
  );
}
